// import React from 'react';
import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import COUNTRY_DIC from './widgets/SearchTourForm/constants/DestinationCountry';

import SearchTourForm from './widgets/SearchTourForm/SearchTourForm';
import SearchIndexForm from './widgets/SearchTourForm/SearchIndexForm';
import SearchTouristForm from './widgets/SearchTourForm/SearchTouristForm';
import RenderCountComponent from './widgets/SearchTourForm/RenderCountComponent';
import SearchHotTourWidget from './widgets/SearchTourForm/SearchHotTourWidget/SearchHotTourWidget';

declare const window: Window &
  typeof globalThis & {
    DEPART_DATA: any;
    DEFAULT_DEPART: any;
    INDEX_TOURS: any;
    LANGUAGE_CODE: String;
    CABINET_HOST: String;
    CACHE_GEO_REGIONS: String;
    COUNTRY_CURRENCY: Object;
    TOURS_REQUEST: Object | null;
    TOUROPERATOR: Object | null;
    TOUROPERATORS_EXCLUDED: Object | null;
    geograftour__json: Object;
    START_DATE: String | null;
    END_DATE: String | null;
    HOTELS: Object | null;
    REGIONS: Object | null;
    SUBREGION: Number | null;
    COUNTRY_DATA: Object;
    DISCOUNT: Object | null;
  };

((w) => {
  w.LANGUAGE_CODE = 'ru' || 'ru';
  w.CABINET_HOST = 'https://cabinet.geograftour.com';
  w.CACHE_GEO_REGIONS = 'geo_regions_default_value';
  w.COUNTRY_CURRENCY = {};
  w.START_DATE = w.START_DATE || null;
  w.END_DATE = w.END_DATE || null;
  w.COUNTRY_DATA = w.COUNTRY_DATA || {
    id: 47,
    name: 'Египет',
    url: 'egipet',
  };
  w.TOUROPERATOR = w.TOUROPERATOR || null;
  w.TOUROPERATORS_EXCLUDED = w.TOUROPERATORS_EXCLUDED || [];
  w.TOURS_REQUEST = w.TOURS_REQUEST || null;
  w.REGIONS = w.REGIONS || null;
  w.SUBREGION = w.SUBREGION || null;
  w.HOTELS = w.HOTELS || null;
  w.DISCOUNT = w.DISCOUNT || [];

  w.geograftour__json = {
    START_DATE: '25/09/2024',
    END_DATE: '29/09/2024',
    PRICE_TO: '',
    HIDE_REGULAR: false,
    TOUROPERATORS: null,
    REGIONS: null,
    SUBREGION: null,
    HOTELS: null,
    MEAL: null,
    STARS: null,
    ADULT: null,
    CHILD: null,
    HOTEL_CUSTOM_TYPE: null,
    SERVICE: null,
    MIN_NIGTHS: null,
    MAX_NIGTHS: null,
  };
})(window);

export const GlobalContext = React.createContext({});
const globalObject = window.geograftour__json;
const DEPART_DATA = window.DEPART_DATA; // проверяем существование глобальной переменной
const DEFAULT_DEPART = window.DEFAULT_DEPART; // проверяем существование глобальной переменной
const GLOBAL = window;

const router = createBrowserRouter([
  {
    path: '/',
    element: <SearchIndexForm DEPART_DATA={DEPART_DATA} />,
  },
  {
    path: '/agency/tour/',
    element: <SearchTourForm DEPART_DATA={DEPART_DATA} />,
  },
  {
    path: '/tours/*',
    element: (
      <SearchTouristForm
        GLOBAL={GLOBAL}
        DEPART_DATA={DEPART_DATA}
        PAGE={`tours`}
      />
    ),
  },
  {
    path: '/tourist/goryashie-tury/',
    element: (
      <SearchHotTourWidget
        DEFAULT_DEPART={DEFAULT_DEPART}
        COUNTRY_DIC={COUNTRY_DIC}
        GLOBAL={GLOBAL}
        DEPART_DATA={DEPART_DATA}
        PAGE={`hot`}
      />
    ),
  },
  {
    path: '/tourist/*',
    element: (
      <SearchTouristForm
        GLOBAL={GLOBAL}
        DEPART_DATA={DEPART_DATA}
        PAGE={`tourist`}
      />
    ),
  },
  {
    path: '/office/*',
    element: (
      <SearchTouristForm
        GLOBAL={GLOBAL}
        DEPART_DATA={DEPART_DATA}
        PAGE={`office`}
      />
    ),
  },
  {
    path: '/tours/hot/*',
    element: (
      <SearchTouristForm
        GLOBAL={GLOBAL}
        DEPART_DATA={DEPART_DATA}
        PAGE={`hot`}
      />
    ),
  },
  {
    path: '/test/*',
    element: (
      <RenderCountComponent
        GLOBAL={GLOBAL}
        DEPART_DATA={DEPART_DATA}
        PAGE={`test`}
      />
    ),
  },
  {
    path: '/*',
    element: (
      <SearchTouristForm
        GLOBAL={GLOBAL}
        DEPART_DATA={DEPART_DATA}
        PAGE={`custom`}
      />
    ),
  },
]);

function App() {
  return (
    <GlobalContext.Provider value={globalObject}>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
